export default __webpack_public_path__ + "static/media/55t.a7846fa6.jpg";